import * as React from 'react';
import { useSelector } from 'react-redux';

import { HomeownerInfo } from '../../../../components/BottomAuthorBlockNew';
import { CardSectionNew } from '../../../../components/CardSectionNew';
import { offerSelector, selectAgentName, selectIsByHomeowner, selectOfferAgent } from '../../../../selectors';
import { selectAgentAvatarUrl } from '../../../../selectors/offerData/agent';
import { PhonesContainer } from '../../../AsideContacts/PhonesContainer';
import { AuthorSendMessageContainer } from '../../../AuthorSendMessage';

export const HomeownerInfoContainer: React.FC = () => {
  const { homeownerProofs } = useSelector(offerSelector);
  const agent = useSelector(selectOfferAgent);
  const isByHomeowner = useSelector(selectIsByHomeowner);

  const avatar = useSelector(selectAgentAvatarUrl);
  const userName = useSelector(selectAgentName);

  if (!agent || !isByHomeowner) {
    return null;
  }

  return (
    <CardSectionNew>
      <HomeownerInfo
        avatar={avatar}
        userName={userName}
        homeownerProofs={homeownerProofs}
        contactButton={<PhonesContainer trackingAction="Open_card_agent_block" size="XS" />}
        chatButton={<AuthorSendMessageContainer />}
      />
    </CardSectionNew>
  );
};
